import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const Button = ({ children, color, className, ...rest }) => {
  const mergedClassName = `${styles[color]} ${className}`;
  return (
    <button className={mergedClassName} {...rest}>
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  className: PropTypes.string,
};

Button.defaultProps = {
  color: 'normal',
  className: '',
};

export default Button;
